import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function BorderCountry(props) {

  const border = props.border;
  const theme = props.theme;
  const [countries, setCountry] = useState([]);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    fetch("https://restcountries.eu/rest/v2/all?fields=name;alpha3Code")
      .then(res => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setCountry(result);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      )
  }, [])

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <h1 className="text-sm">Fetching...</h1>
    );
  } else {
    return (
      theme ?
        countries.filter(country => country.alpha3Code === border).map(borderCountry => (
          <div className="bg-white py-1 px-4 rounded-md shadow-lg mr-2 mb-2 transform transition-transform duration-300 
          hover:scale-105">
            <Link to={`/countries/${borderCountry.name}`}>
              <h6 className="text-sm text-center sm:text-base md:text-lg lg:text-sm"> {borderCountry.name} </h6>
            </Link>
          </div>
        ))
        :
        countries.filter(country => country.alpha3Code === border).map(borderCountry => (
          <div className="bg-gray-800 py-1 px-4 rounded-md shadow-lg mr-2 mb-2 transform transition-transform duration-300 
          hover:scale-105" >
            <Link to={`/countries/${borderCountry.name}`}>
              <h6 className="text-gray-400 text-sm text-center sm:text-base md:text-lg lg:text-sm"> {borderCountry.name} </h6>
            </Link>
          </div>
        ))
    );
  }
}

export default BorderCountry;